import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Fragment } from "react";
import useTranslate from "../../../core/languages/hooks/useTranslate";
import {Link, useLocation} from "react-router-dom";

type UserDropdownProps = {
  userDisplayName?: string;
  onClick?: () => void;
}

export default function UserDropdown(props: UserDropdownProps) {
  const t = useTranslate();
  const location = useLocation();
    const inProfileView = location.pathname === "/profile" ? "bg-gray-100 dark:bg-neutral-700" : "opacity-80";
  const inBookingView = location.pathname === "/bookings" ? "bg-gray-100 dark:bg-neutral-700" : "opacity-80";
  const inTransfersView = location.pathname === "/transfers" ? "bg-gray-100 dark:bg-neutral-700" : "opacity-80";

  return (
      <div className="CurrencyDropdown">
        <Popover className="relative">
          {({ open, close }) => (
              <>
                <Popover.Button
                    className={`
                ${open ? "" : "text-opacity-80"}
                bg-neutral-100 group px-4 py-2 border-neutral-300 hover:border-neutral-400 dark:border-neutral-700 rounded-full inline-flex items-center text-sm text-gray-700 dark:text-neutral-300 font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
                >
                  <span className="ml-2 select-none">{props.userDisplayName}</span>
                  <ChevronDownIcon
                      className={`${open ? "-rotate-180" : "text-opacity-70"}
                  ml-2 h-4 w-4  group-hover:text-opacity-80 transition ease-in-out duration-150`}
                      aria-hidden="true"
                  />
                </Popover.Button>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-10 w-screen max-w-[140px] px-4 mt-4 right-0 sm:px-0">
                    <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black ring-opacity-5">
                      <div className="relative grid gap-7 bg-white dark:bg-neutral-800 p-7">
                        <Link
                          to="/profile"
                          key={'789'}
                          className={`flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50 ${inProfileView}`}
                        >
                          <p className="ml-2 text-sm font-medium ">{t("mainNav.profile")}</p>
                        </Link>
                        <Link
                          to="/bookings"
                          key={'456'}
                          className={`flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50 ${inBookingView}`}
                        >
                          <p className="ml-2 text-sm font-medium ">{t("mainNav.bookings")}</p>
                        </Link>
                        <Link
                          to="/transfers"
                          key={'789transfers'}
                          className={`flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50 ${inTransfersView}`}
                        >
                          <p className="ml-2 text-sm font-medium ">{t("mainNav.transfers")}</p>
                        </Link>
                        <Link
                            key={'123'}
                            to={''}
                            onClick={props.onClick}
                            className={`flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50`}
                        >
                          <p className="ml-2 text-sm font-medium ">{t("mainNav.logout")}</p>
                        </Link>
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
          )}
        </Popover>
      </div>
  );
}
